module.exports = require('./helpers/bundle-url').getBundleURL('aWUjo') + "apta_qr_code.de6b7f81.png";